import { useMemo } from "react";
import { FileType } from "../utils/file-manager";
import { useQuery } from "@tanstack/react-query";
import { fetchMediaFiles } from "../services/media-files-service";
import { useConfig } from 'hooks/use-config';
import { getExtensionsForFileType } from "../utils/file-manager";
import { DateRange } from "../components/common-filters";
import { SortingState } from "@tanstack/react-table";

interface QueryParams {
    filter: {
        name?: string;
        fileType?: FileType;
        lastModified?: DateRange;
    };
    page: number;
    pageSize: number;
    sort?: SortingState
}

export const useMediaFilesQuery = (queryParams: QueryParams) => {
    const { configurationSettings } = useConfig();

    const memoizedQueryParams = useMemo(
        () => ({
            page: queryParams.page,
            pageSize: queryParams.pageSize,
            filterName: queryParams.filter.name ?? '',
            filterFileType: getExtensionsForFileType(queryParams.filter.fileType),
            startTs: queryParams.filter.lastModified?.from?.getTime(),
            endTs: queryParams.filter.lastModified?.to?.getTime(),
            sort: queryParams?.sort || [{ id: 'createdDate', desc: true }]
        }),
        [queryParams.page, queryParams.pageSize, queryParams.filter.name, queryParams.filter.fileType, queryParams.filter.lastModified, queryParams?.sort]
    );
    return useQuery({
        queryKey: ['media-files', memoizedQueryParams],
        queryFn: () => fetchMediaFiles(configurationSettings, memoizedQueryParams)
    })
}